export enum SessionStatus {
  PLANNED = "PLANNED",
  IN_PROGRESS = "IN_PROGRESS",
  HOLD = "HOLD",
  PAUSED = "PAUSED",
  WAITING_EXPERT = "WAITING_EXPERT",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum PresentationStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  ARCHIVED = "ARCHIVED",
}

export enum SessionMode {
  AUTOMATIC = "AUTOMATIC",
  MANUAL = "MANUAL",
}

export enum UserRole {
  OPERATOR = "OPERATOR",
  USER = "USER",
  CREATOR = "CREATOR",
  ROOT_CREATOR = "ROOT_CREATOR",
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  GUEST = "GUEST",
}

export enum InfoStepType {
  TEXT_WITH_CAPTION = "TEXT_WITH_CAPTION",
  TWO_COLUMNS_LIST = "TWO_COLUMNS_LIST",
  LIST = "LIST",
  IMAGE = "IMAGE",
  IMAGE_GRAPH = "IMAGE_GRAPH",
  TABLE = "TABLE",
  GRAPH = "GRAPH",
  LAYOUT = "LAYOUT",
  BACKGROUND_IMAGE = "BACKGROUND_IMAGE",
  BACKGROUND_VIDEO = "BACKGROUND_VIDEO",
  BACKGROUND_VR = "BACKGROUND_VR",
}

export enum InfoStepListItemType {
  TEXT = "TEXT",
  GROUP = "GROUP",
  IMAGE = "IMAGE",
  PRICE = "PRICE",
  PERSONS = "PERSONS",
  CHECKED = "CHECKED",
  CALCULATED = "CALCULATED",
  PERCENT_PRICE = "PERCENT_PRICE",
  CHECKED_CALCULATED = "CHECKED_CALCULATED",
}

export enum WithoutResponseType {
  RESPONSE_TIME = "RESPONSE_TIME",
  INACTIVITY = "INACTIVITY",
}

export enum ActionType {
  BOOKING = "BOOKING",
  INFORMATION = "INFORMATION",
  FEEDBACK = "FEEDBACK",
  SEND_EVENT = "SEND_EVENT",
}

export enum ActionClickEventType {
  SEND_EVENT = "SEND_EVENT",
}

export enum ActionInfoPosition {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  CENTER = "CENTER",
}

export enum ActionResponseType {
  NONE = "NONE",
  STEP = "STEP",
  DECISION = "DECISION",
}

export enum ActionResponseDecisionType {
  CONFIRMATION = "CONFIRMATION",
  REJECTION = "REJECTION",
}

export enum ActionResponseHandleType {
  DEFAULT = "DEFAULT",
  CREATE_PRESENTATION_SESSION = "CREATE_PRESENTATION_SESSION",
}

export enum ActionBookingType {
  MEETING_WITH_EMPLOYEES = "MEETING_WITH_EMPLOYEES",
  SCHEDULE_PRESENTATION = "SCHEDULE_PRESENTATION",
}

export enum ActionBookingVariant {
  MONTHLY = "MONTHLY",
  WEEKLY = "WEEKLY",
}

export enum ActionWaitingRoomType {
  START = "START",
  RESTART = "RESTART",
  RESUME = "RESUME",
}

export enum ProjectType {
  APARTMENT_BUILDING = "APARTMENT_BUILDING",
  SINGLE_FAMILY_HOUSING_DEVELOPMENT = "SINGLE_FAMILY_HOUSING_DEVELOPMENT",
  RESIDENTIAL_COMPLEX = "RESIDENTIAL_COMPLEX",
  URBAN_DISTRICT = "URBAN_DISTRICT",
  QUARTER = "QUARTER",
  MULTIFUNCTIONAL_COMPLEX = "MULTIFUNCTIONAL_COMPLEX",
  APARTHOTEL = "APARTHOTEL",
}

export enum ProjectObjectType {
  APARTMENT_BUILDING = "APARTMENT_BUILDING",
  TERRACED_HOUSE = "TERRACED_HOUSE",
  COMMERCIAL_BUILDING = "COMMERCIAL_BUILDING",
  RESIDENTIAL_AND_COMMERCIAL_BUILDING = "RESIDENTIAL_AND_COMMERCIAL_BUILDING",
  CHILDRENS_PLAYGROUND = "CHILDRENS_PLAYGROUND",
  UNDERGROUND_PARKING_AREA = "UNDERGROUND_PARKING_AREA",
  BASEMENT_AREA = "BASEMENT_AREA",
  BICYCLE_PARKING_AREA = "BICYCLE_PARKING_AREA",
  PARKING_AREA = "PARKING_AREA",
  BUILDING_SECTION = "BUILDING_SECTION",
  GARDEN_AREA = "GARDEN_AREA",
  HOUSE = "HOUSE",
  APARTMENT = "APARTMENT",
  PARKING_SPACE = "PARKING_SPACE",
  BICYCLE_PARKING_SPACE = "BICYCLE_PARKING_SPACE",
  GARDEN_PLOT = "GARDEN_PLOT",
  STORAGE_ROOM = "STORAGE_ROOM",
  CELLAR_COMPARTMENT = "CELLAR_COMPARTMENT",
}

export enum LayoutRoomType {
  KITCHEN = "KITCHEN",
  BATHROOM = "BATHROOM",
  HALLWAY = "HALLWAY",
  LIVING_ROOM = "LIVING_ROOM",
  BEDROOM = "BEDROOM",
  HOME_OFFICE = "HOME_OFFICE",
  STORAGE_ROOM = "STORAGE_ROOM",
  DRESSING_ROOM = "DRESSING_ROOM",
  WARDROBE = "WARDROBE",
  CHILDRENS_ROOM = "CHILDRENS_ROOM",
  DINING_ROOM = "DINING_ROOM",
  DINING_AREA = "DINING_AREA",
  BALCONY = "BALCONY",
  TERRACE = "TERRACE",
  LOGGIA = "LOGGIA",
  GUEST_ROOM = "GUEST_ROOM",
  GUEST_TOILET = "GUEST_TOILET",
  UTILITY_ROOM = "UTILITY_ROOM",
  PANTRY = "PANTRY",
  CONSERVATORY = "CONSERVATORY",
  BASEMENT = "BASEMENT",
  ATTIC_ROOM = "ATTIC_ROOM",
}

export enum PostPublishStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  ARCHIVED = "ARCHIVED",
}

export enum PostStatus {
  OPEN = "OPEN",
  BOOKED = "BOOKED",
  CLOSED = "CLOSED",
}

export enum PostType {
  SALE = "SALE",
  RENT = "RENT",
}

export enum DeveloperObjectType {
  PROJECT = "PROJECT",
  PROJECT_OBJECT = "PROJECT_OBJECT",
  LAYOUT = "LAYOUT",
}

export enum LandShareType {
  PERCENT = "PERCENT",
  PRICE = "PRICE",
}

export enum SmallAvatarPosition {
  TOP_RIGHT = "top-right",
  TOP_LEFT = "top-left",
  BOTTOM_RIGHT = "bottom-right",
  BOTTOM_LEFT = "bottom-left",
}

export enum GalleryType {
  PHOTOS = "PHOTOS",
  PLANS = "PLANS",
}

export enum ListIds {
  INVEST_OBJECTS = 17,
  ACADEMY = 16,
  CALCULATOR = 15,
  BOOKING = 19,
  LOGIN = 23,
  OTHER_LOCATION = 18,

  BLOG_SUBSCRIPTION = 12,
  HANDBOOK_SUBSCRIPTION = 13,
}

export enum SortOptionType {
  RENTAL_YIELD = "rentalYield",
  INVESTOR_CASH_FLOW_AVERAGE = "investorCashFlowAverage",
  IRR_BY_YEAR = "irrByYear",
  EARLY_SALE_PROFIT = "earlySaleProfit",
}

export enum ListingType {
  PUBLIC = 'PUBLIC',
  PRE_SALE = 'PRE_SALE',
  OFF_MARKET = 'OFF_MARKET',
}